import React from 'react';
import { FilterPanelMain } from '@src/common/FilterPanelPage/FilterPanelMain';
import { FilterPanel } from '@src/common/FilterPanelPage/FilterPanel';
import { ResultsContent } from '@src/common/FilterPanelPage/results/ResultsContent';
import { RiskScoresFilterPanel } from './RiskScoresFilterPanel';
import { RiskScoresResults } from './RiskScoresResults';
import { RiskAnalysisLoadingAttr } from './filterPanelComponents/RiskScoresLoadingAttr';
import '../mothership/riskScroresNavObserver';

export const RiskScoresPage = () => {
  return (
    <FilterPanelMain>
      <FilterPanel>
        <RiskAnalysisLoadingAttr />
        <RiskScoresFilterPanel />
      </FilterPanel>
      <ResultsContent>
        <RiskScoresResults />
      </ResultsContent>
    </FilterPanelMain>
  );
};
